import { styled } from "styled-components";

export const ProductView = styled.div`
  width: 100%;
  padding-left: 12px;
`;
